import React from "react";
import { Input } from "@/components/ui/input";
import { money } from "@/lib/constants";
import { useLang } from "@/i18n";

export const DENOMS = [500, 200, 100, 50, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05, 0.02, 0.01];
export const denomTotal = (counts) =>
  Math.round(DENOMS.reduce((s, d) => s + d * (Number(counts?.[String(d)]) || 0), 0) * 100) / 100;
const label = (d) => (d >= 5 ? `€ ${d}` : d >= 1 ? `€ ${d}` : `${Math.round(d * 100)}c`);

/** Telhulp: aantal per biljet en munt, totaal wordt automatisch berekend. */
export default function CashCount({ title, counts, setCounts, testid }) {
  const { t } = useLang();
  const total = denomTotal(counts);
  const set = (d) => (e) => setCounts({ ...counts, [String(d)]: e.target.value.replace(/\D/g, "") });
  return (
    <div className="rounded-xl border border-border p-4 space-y-3" data-testid={testid}>
      <div className="flex items-baseline justify-between">
        <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-muted-foreground">{title}</p>
        <p className="font-display font-extrabold text-xl tabular-nums text-primary" data-testid={`${testid}-total`}>{money(total)}</p>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
        {DENOMS.map((d) => (
          <div key={d} className="flex items-center gap-1.5">
            <span className={`w-12 shrink-0 text-xs tabular-nums ${d >= 5 ? "font-semibold text-foreground" : "text-muted-foreground"}`}>{label(d)}</span>
            <Input inputMode="numeric" value={counts?.[String(d)] ?? ""} onChange={set(d)}
              className="h-8 px-2 text-sm tabular-nums" placeholder="0" data-testid={`${testid}-${String(d).replace(".", "-")}`} />
          </div>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground">{t("cash_count_hint")}</p>
    </div>
  );
}
